import React, {useEffect, useState} from "react";
import {Navigate, NavLink} from "react-router-dom";
import "./topbar.scss"
import AdminLogo from "src/assets/logo/logo-VT-admin.svg"
import {Badge, Col, Divider, Popover, Row} from "antd";
import {PRIVATE_ADMIN_ROUTE, PRIVATE_COMPANY_ROUTE, PUBLIC_ROUTE} from "src/route.constants";
import {useNavigate} from "react-router";
import {FormattedMessage, injectIntl} from "react-intl";
import {ICONS} from "src/assets/sprite/iconsNames";
import actions from "src/redux/auth/actions";
import drawerActions from "src/redux/drawer/actions";
import {useDispatch, useSelector} from "react-redux";
import Icon from "src/component/Icon/Sprite";
import notificationActions from "../../../redux/notification/actions";
import {NOTIFICATION_TYPE} from "../../../utils/utility";
import dayjs from "dayjs";

const {logout} = actions
const {closeDrawer} = drawerActions

function AdminTopbar() {
    const relativeTime = require('dayjs/plugin/relativeTime')
    dayjs.extend(relativeTime)

    const {getAllNotification, setNotificationRead} = notificationActions
    const dispatch = useDispatch();

    const navigate = useNavigate()

    const listNotification = useSelector(state => state.Notification.listNotification)
    const notificationCount = useSelector(state => state.Notification.notificationCount)

    function setAllRead() {
        let ids = []
        let tempList = [...listNotification]
        tempList = tempList.filter(notification => !notification.read)
        tempList.forEach(notification => ids = ids.concat(notification.ids))
        if (ids.length !== 0) {
            dispatch(setNotificationRead(ids))
        }
    }

    const logOut = () => {
        dispatch(closeDrawer())
        dispatch(logout(navigate))
    }
    useEffect(() => {
        dispatch(getAllNotification())
    }, [])

    return (
        <>
            <div className="adminTopbar">
                <div className="sidePadding">
                    <div className="topbarContent flex-center-between">
                        <div className="pointer" onClick={()=> navigate(PRIVATE_ADMIN_ROUTE.DASHBOARD)}>
                            <img src={AdminLogo} className={"logo"}/>
                        </div>
                        <div className="menuContainer">
                            <ul>
                                <li>
                                    <NavLink to={PRIVATE_ADMIN_ROUTE.COMPANIES} className={({isActive}) => isActive ? 'active' : null}>
                                        <FormattedMessage id="topBar_AdminCompanies"/>
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to={PRIVATE_ADMIN_ROUTE.USERS} className={({isActive}) => isActive ? 'active' : null}>
                                        <FormattedMessage id="topBar_AdminUsers"/>
                                    </NavLink>
                                </li>
                                <Divider type={"vertical"} style={{backgroundColor: "#FFFFFF", opacity: "0.2", height: "32px"}}/>
                                <li>
                                    <Popover
                                        overlayClassName="notifyPopover"
                                        placement={"bottomRight"}
                                        getPopupContainer={triggerNode => triggerNode.parentElement}
                                        trigger="click"
                                        content={
                                            <div style={{minHeight: "500px", maxHeight: "70vh"}}>
                                                <div className={"header notifyPadding flex-center-between"}>
                                                    <div className="size-16 weight-700">
                                                        <FormattedMessage id="topBar_notification"/>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className={"notifyPadding border-bottom flex-end"}>

                                                        <div className="flex-align-center opacity-50">
                                                            <div className="flex-align-center margin-left-18">
                                                                <Icon className="opacity-50" name={ICONS.tik_all_read} size={[20, 20]} color={"#0E0E2C"}/>
                                                            </div>

                                                            <div className="size-14 weight-600 underlined pointer" onClick={() => setAllRead()}>
                                                                <FormattedMessage id="topBar_MarkAsRead"/>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    {listNotification && listNotification.map((notify) => {
                                                        if (notify.type === NOTIFICATION_TYPE.NEW_COMPANY) {
                                                            return (
                                                                <Row className="notifyPadding pointer border-bottom" onClick={() => dispatch(setNotificationRead(notify.ids))}>
                                                                    <Col span={4}>
                                                                        <div className="notifyIcon flex-center">
                                                                            <Icon name={ICONS.user} size={[20, 20]} color={"#0E0E2C"}/>
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={20}>
                                                                        <div className="flex-center-between">
                                                                            <div className="flex-align-center">
                                                                                <div className={`size-14 ${!notify.read && "weight-700"}`}>
                                                                                    {notify.ids && notify.ids.length}
                                                                                    &nbsp;
                                                                                    {notify.ids && notify.ids.length === 1 ?
                                                                                        <FormattedMessage id="notification_newCompany"/>
                                                                                        :
                                                                                        <FormattedMessage id="notification_newCompanies"/>
                                                                                    }
                                                                                </div>
                                                                            </div>

                                                                            <div className="flex-center">
                                                                                <div className="size-12 opacity-70 margin-left-8">
                                                                                    {notify.dateCreated && dayjs(notify.dateCreated).fromNow(true)} fa
                                                                                </div>
                                                                                {notify.read ?
                                                                                    <div className="tik">
                                                                                        <Icon name={ICONS.tik} size={[20, 20]} color={"#208AC6"}/>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="blueCircle"/>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className="blue" style={{width: "fit-content"}} onClick={() => {
                                                                            dispatch(setNotificationRead(notify.ids))
                                                                        }}>
                                                                            {notify.offert && notify.offert.title}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        } else {
                                                            return (
                                                                <Row className="notifyPadding pointer border-bottom" onClick={() => dispatch(setNotificationRead(notify.ids))}>
                                                                    <Col span={4}>
                                                                        <div className="notifyIcon flex-center">
                                                                            <Icon name={ICONS.doc} size={[20, 20]} color={"#0E0E2C"}/>
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={20}>
                                                                        <div className="flex-center-between">
                                                                            <div className="flex-align-center">
                                                                                <div className={`size-14 ${!notify.read && "weight-700"}`}>
                                                                                    <div>
                                                                                        <span>
                                                                                            L'offerta&nbsp;
                                                                                        </span>
                                                                                        <span className="blue" style={{width: "fit-content"}}>
                                                                                            {notify.offert && notify.offert.title}
                                                                                        </span>
                                                                                        <span>
                                                                                            &nbsp;è stata pubblicata
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex-center">
                                                                                <div className="size-12 opacity-70 margin-left-8">
                                                                                    {notify.dateCreated && dayjs(notify.dateCreated).fromNow(true)} fa
                                                                                </div>
                                                                                {notify.read ?
                                                                                    <div className="tik">
                                                                                        <Icon name={ICONS.tik} size={[20, 20]} color={"#208AC6"}/>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="blueCircle"/>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        }
                                                    })}
                                                </div>
                                                <div className="end-border-bottom"/>
                                            </div>
                                        }
                                    >
                                        <Badge className="pointer hover-opacity-70" count={notificationCount} size={"small"}>
                                            <Icon name={ICONS.notify} size={[20, 20]} color={"#FFFFFF"}/>
                                        </Badge>
                                    </Popover>
                                </li>

                                <Divider type={"vertical"} style={{backgroundColor: "#FFFFFF", opacity: "0.2", height: "32px"}}/>

                                <li>
                                    <Popover
                                        overlayClassName="myAccount"
                                        placement={"bottomRight"}
                                        getPopupContainer={triggerNode => triggerNode.parentElement}
                                        trigger="click"
                                        content={
                                            <div className="accountPadding">

                                                <div className="flex-align-center spacing pointer" onClick={() => logOut()}>
                                                    <div className="flex-align-center padding-8">
                                                        <Icon className="opacity-70" name={ICONS.exit} size={[20, 20]} color={"#0E0E2C"}/>
                                                    </div>
                                                    <div className="size-14 weight-500">
                                                        <FormattedMessage id="exit"/>
                                                    </div>
                                                </div>

                                                <div className="flex-align-center spacing pointer" onClick={() => navigate(PRIVATE_ADMIN_ROUTE.SETTINGS)}>
                                                    <div className="flex-align-center padding-8">
                                                        <Icon className="opacity-70" name={ICONS.settings} size={[20, 20]} color={"#0E0E2C"}/>
                                                    </div>
                                                    <div className="size-14 weight-500">
                                                        <FormattedMessage id="Dashboard_settings"/>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    >
                                        <div className="pointer flex hover-opacity-70">
                                            <div>
                                                <div className="size-14 weight-700 line-height-18">
                                                    {localStorage.getItem("firstName") + " " + localStorage.getItem("lastName")}
                                                </div>
                                                <div className="size-12 opacity-70 line-height-16">
                                                    Admin
                                                </div>
                                            </div>
                                            <div className="flex-center">
                                                <Icon name={ICONS.arrow_small} size={[20, 20]} color={"#FFFFFF"}/>
                                            </div>
                                        </div>

                                    </Popover>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default injectIntl(AdminTopbar)

